const state = {
  drawer: false,
  keyboardInfos: [
    {
      type: "subheader",
      text: "Deployment"
    },
    {
      title: "Mobile SDKs",
      icon: "screen_lock_portrait",
      iconClass: "",
      color: "green",
      subtitle: "iOS/Android"
    },
    {
      type: "subheader",
      text: "Features"
    },
    {
      title: "Autocorrect",
      icon: "spellcheck",
      iconClass: "",
      color: "green"
    },
    {
      title: "Autocomplete",
      icon: "forward",
      iconClass: "",
      color: "green"
    }
  ],
  interactInfos: [
    {
      type: "subheader",
      text: "Deployment"
    },
    {
      title: "Mobile SDKs",
      icon: "screen_lock_portrait",
      iconClass: "",
      color: "green",
      subtitle: "iOS/Android"
    },
    {
      title: "Cloud",
      icon: "cloud_done",
      iconClass: "",
      color: "green",
      subtitle: "API Access"
    },
    {
      title: "Local Server",
      icon: "storage",
      iconClass: "",
      color: "green",
      subtitle: "On premise"
    }
  ],
  pageElements: {
    csam_demo: {
      color: "#f38eb1",
    },
    ageassure: {
      color: "#d4242a",
    },
    faceassure: {
      color: "#6ea3d0",
    },
    audio_recording: {
      color: "#f6c835",
    },
    voice_print: {
      color: "#f48227",
    },
    hate_toxicity: {
      color: "#814294",
      img: require("@/assets/images/hate.png"),
      explanation:
        "Our hate speech and toxicity classifiers allow flagging problematic content and are on par with the best-performing cloud APIs in this domain."
    },
    text_age_verification: {
      color: "#09a67b",
      img: require("@/assets/images/age_verification.png"),
      explanation:
        "Out text-based age verification model provides estimates of a user's age based on their input text."
    },
    video_age_verification:{
      color: "#d76a09",
      img: require("@/assets/images/age_verification.png"),
      explanation: "Our video age verification model estimates a user's age based on a short audio-video recording. We can also provide an estimate using only audio or video but using both provides better results"
    },
    video_age_verification_overlay:{
      color: "#d76a09",
      img: require("@/assets/images/age_verification.png"),
      explanation: "Our video age verification model estimates a user's age based on a short audio-video recording. We can also provide an estimate using only audio or video but using both provides better results"
    },
    exp_hate_toxicity: {
      color: "#e14156",
      img: require("@/assets/images/hate.png"),
      explanation:
        "Our hate speech and toxicity classifiers allow flagging problematic content and are on par with the best-performing cloud APIs in this domain."
    },
    emotion: {
      color: "#994b22",
      img: require("@/assets/images/emotions.png"),
      explanation:
        "Our emotion classifiers allow classifying across 7 emotions and are on par with the best-performing cloud APIs in this domain."
    },
    keyboard: {
      color: "#a06ee1",
      img: require("@/assets/images/keyboard.png"),
      explanation: "We produce fully featured custom mobile keyboards, in which we embed our wellbeing assessment tech."
    },
    video: { color: "#6a9bbb", img: require("@/assets/images/gaming.png") },
    image_safety: {
      color: "#849058",
      img: require("@/assets/images/image_safety.png")
    },
    violence: {
      color: "#ff8b6a",
      img: require("@/assets/images/violence.png")
    },
    emotionFace: {
      color: "#c19191",
      img: require("@/assets/images/emotionFace.png")
    },
    multimodal_emotion: {
      color: "#f17e7e",
      img: require("@/assets/images/multimodal.png")
    }
  }
};

const getters = {
  drawer: state => {
    return state.drawer;
  },
  pageElements: state => {
    return state.pageElements;
  },
  interactInfos: state => {
    return state.interactInfos;
  },
  keyboardInfos: state => {
    return state.keyboardInfos;
  }
};

const mutations = {
  setDrawer: (state, payload) => {
    state.drawer = payload;
  }
};

const actions = {
  setDrawer: ({ commit }, payload) => {
    commit("setDrawer", payload);
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
